import { Button } from '../../components/button';

export type FacilitySettingsPanelModel = {
  shift_length?: number | null;
  shift_start_day?: string | null;
  shift_start_night?: string | null;
  shift_start_24h?: string | null;
};

export type FacilitySettingsPanelProps = {
  facility: FacilitySettingsPanelModel;
  canEdit?: boolean;
  onEditClick?: () => void;
};

const formatTimeDisplay = (timeStr?: string | null): string => {
  if (!timeStr) return '--';
  const [hoursStr, minutesStr] = timeStr.split(':');
  const hours = parseInt(hoursStr || '0', 10);
  const minutes = parseInt(minutesStr || '0', 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return '--';
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHours}:${String(minutes).padStart(2, '0')} ${period}`;
};

export function FacilitySettingsPanel({
  facility,
  canEdit = false,
  onEditClick,
}: FacilitySettingsPanelProps) {
  const showEdit = Boolean(canEdit && onEditClick);

  return (
    <section className="tw:pb-8">
      <div className="tw:flex tw:justify-between tw:items-start tw:mb-4">
        <h2 className="tw:!text-base tw:!font-semibold tw:!text-brand-green-0 tw:!mb-0">
          Assignment Configuration
        </h2>
        {showEdit && (
          <Button color="brand-green-outline" onClick={onEditClick}>
            <i className="fa-solid fa-pen-to-square" />
            Edit
          </Button>
        )}
      </div>
      <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-8 tw:gap-y-6">
        <div>
          <div className="tw:text-zinc-400 tw:text-sm">Shift Length (Hours)</div>
          <div className="tw:text-zinc-700">
            {facility.shift_length != null ? facility.shift_length : '--'}
          </div>
        </div>
        <div>
          <div className="tw:text-zinc-400 tw:text-sm">24 Hr Shift Start Time</div>
          <div className="tw:text-zinc-700">{formatTimeDisplay(facility.shift_start_24h)}</div>
        </div>
        <div>
          <div className="tw:text-zinc-400 tw:text-sm">Day Shift Start Time</div>
          <div className="tw:text-zinc-700">{formatTimeDisplay(facility.shift_start_day)}</div>
        </div>
        <div>
          <div className="tw:text-zinc-400 tw:text-sm">Night Shift Start Time</div>
          <div className="tw:text-zinc-700">{formatTimeDisplay(facility.shift_start_night)}</div>
        </div>
      </div>
    </section>
  );
}
